/**
 * Environment variables
 */
export const Env = {
    MODE: process.env.NODE_ENV || "development",
    APP_NAME: process.env.REACT_APP_NAME,
    BASE_URL: process.env.REACT_APP_API_URL,
  };
  